import React from "react";
import classnames from "classnames";
import { AppPermissions, useHasPermission, useOutsideClick } from "..";

const GlobalAddButton: React.FunctionComponent<{
  className?: string;
  setAddModal?: (type: string) => void;
}> = (props) => {
  const [showDropDown, setShowDropDown] = React.useState(false);

  const ref = React.useRef<HTMLDivElement>(null);
  useOutsideClick(ref, () => {
    setShowDropDown(false);
  });

  return (
    <div className="dropdown" ref={ref}>
      <div
        className={`headerAdd ${props.className || ""} ${
          showDropDown ? "text-white bg-primary" : ""
        }`}
        onClick={() => setShowDropDown(!showDropDown)}
      >
        <i className={`${showDropDown ? "icon-close" : "icon-plus"} `}></i>
      </div>
      <ul
        className={classnames({
          "dropdown-menu dropdown-shadow font-sm border-0": true,
          in: showDropDown,
        })}
      >
        <i>
          <button
            className="dropdown-item px-3 py-2 font-base"
            onClick={() => {
              props.setAddModal?.("Lead");
              setShowDropDown(false);
            }}
          >
            <i className="icon-lead mr-2"></i> Lead
          </button>
        </i>
        <i>
          <button
            className="dropdown-item px-3 py-2 font-base"
            onClick={() => {
              props.setAddModal?.("Activity");
              setShowDropDown(false);
            }}
          >
            <i className="icon-calendar mr-2"></i> Activity
          </button>
        </i>
        <i>
          <button
            className="dropdown-item px-3 py-2 font-base"
            onClick={() => {
              props.setAddModal?.("Customer");
              setShowDropDown(false);
            }}
          >
            <i className="icon-users mr-1"></i> Customer
          </button>
        </i>
      </ul>
    </div>
  );
};

export default GlobalAddButton;
